import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

// 兑换站只保留面向用户的公开路由；管理后台与登录鉴权已拆分到独立项目。
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomeView.vue'), // 兑换码输入 / 兑换主页
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/subscription',
    redirect: '/recharge',
  },
  {
    path: '/lookup',
    redirect: '/history',
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFoundView.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

export default router
